import {useCallback} from 'react';
import {showToast, clearAllToasts, ToastMessage} from '@/core/store/app';

interface UseToastOptions {
  duration?: number;
}

export const useToast = () => {
  const show = useCallback((type: ToastMessage['type'], text: string, options: UseToastOptions = {}) => {
    showToast({
      type,
      text,
      duration: options.duration ? options.duration : 2000,
    });
  }, []);

  const showSuccess = useCallback(
    (text: string, options?: UseToastOptions) => {
      show('success', text, options);
    },
    [show],
  );

  const showError = useCallback(
    (text: string, options?: UseToastOptions) => {
      show('error', text, options);
    },
    [show],
  );

  const showWarning = useCallback(
    (text: string, options?: UseToastOptions) => {
      show('warning', text, options);
    },
    [show],
  );

  const showInfo = useCallback(
    (text: string, options?: UseToastOptions) => {
      show('info', text, options);
    },
    [show],
  );

  const clear = useCallback(() => {
    clearAllToasts();
  }, []);

  return {
    show,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clear,
  };
};
